export default {"src":"/_next/static/media/icon_left_arrow.7d92774d.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};